import React, {PureComponent} from "react"
import {OverlayTrigger, Tooltip} from "react-bootstrap"

import Icon from "../../Icon"
import Flex from "../../Flex"

import {StyledInfo, StyledTooltip} from "../styled/InfoTooltip"

interface Props {
  tooltip: string,
  position?: string,
  customIcon?: boolean
}

export default class extends PureComponent<Props> {
  static defaultProps: Pick<Props, "customIcon" | "position"> = {
    position: "left",
    customIcon: false
  }

  render() {
    const {tooltip, position, customIcon} = this.props
    const Overlay = customIcon ? StyledTooltip : Tooltip
    return (
      <OverlayTrigger placement={position} overlay={<Overlay id="tooltip">{tooltip}</Overlay>}>
        {customIcon ? (
          <Flex justifyContent="flex-end">
            <Icon icon="info" />
          </Flex>
        ) : (
          <StyledInfo size={18} />
        )}
      </OverlayTrigger>
    )
  }
}
